import { api } from '../../shared/api/client';

/** Parte del orden del culto con sus pasajes de la Biblia (lo que la consola necesita). */
export type OrderPart = { segmentId: string; name: string; link: string | null; ministry: { systemKey?: string | null } | null; passages?: { id: string; passage: string; translation: string | null }[] };

/** El orden del culto con sus pasajes; si no se puede leer (permiso, red), vacío. */
export async function orderParts(churchId: string, serviceId: string): Promise<OrderPart[]> {
  try {
    return (await api.get<{ items: OrderPart[] }>(`/worship/churches/${churchId}/services/${serviceId}/order`)).items;
  } catch {
    return [];
  }
}

const KEY = (presentationId: string) => `keora.consola.pasajes.${presentationId}`;

/** Pasajes del orden que ya entraron a ese programa (si alguien los quita, no vuelven a entrar). */
export function importedPassages(presentationId: string): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY(presentationId)) ?? '[]') as string[]);
  } catch {
    return new Set();
  }
}

export function rememberPassages(presentationId: string, ids: Iterable<string>) {
  try {
    localStorage.setItem(KEY(presentationId), JSON.stringify([...new Set([...importedPassages(presentationId), ...ids])].slice(-500)));
  } catch {
    // Sin almacenamiento: a lo más se vuelve a ofrecer.
  }
}
